<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.95 33">
        <title>forecast-icon</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_4" data-name="Layer 4">
                <g>
                    <rect x="14.12" y="13.4" width="5.51" height="19.6" transform="translate(33.76 46.4) rotate(180)" :fill="color" />
                    <rect x="7.06" y="19.79" width="5.51" height="13.21" transform="translate(19.64 52.79) rotate(180)" :fill="color" />
                    <rect y="25.18" width="5.51" height="7.82" transform="translate(5.51 58.18) rotate(180)" :fill="color" />
                    <polygon points="28.95 9.52 23.94 0 18.93 9.52 21.18 9.52 21.18 33 26.7 33 26.7 9.52 28.95 9.52" :fill="color" />
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
export default {
    props: {
        color: {
            type: String,
            required: false,
            default: "f000"
        }
    }
};
</script>



// WEBPACK FOOTER //
// ForecastIcon.vue?4bb5c8e8